import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import { convertHarfCharacter } from '../../utility'

export default function MyReactSelect (props) {
  const { labelText, selectProps, options } = props
  const useAuto = selectProps.useauto && !selectProps.readonly
  const getValueFromEventValue = (v) => v.value

  const [value, setValue] = useState(options.find((option) => option.value === selectProps.value) || null)
  const onChange = props.linkMode ? (v) => { location.href = getValueFromEventValue(v) } : (v) => { setValue(v); props.onChange(v) }
  const valueRef = useRef(null)

  const [error, setError] = useState(props.error)

  useEffect(() => {
    const valueQ = $(useAuto ? valueRef.current : valueRef.current.node)
    valueQ.trigger('change') // コードからの変更ではchangeイベントが発火しないので、手動で発火させる

    const messageOnSelected = props.messagesOnSelected.find(p => p.length === 2 && p[0] === value?.value)
    if (messageOnSelected) {
      setError(messageOnSelected[1])
    } else {
      setError(null)
    }
  }, [value])

  return (useAuto
    ? (
    <>
      <Autocomplete
        value={value}
        options={options}
        className={`${selectProps.class}`}
        getOptionLabel={(option) => option ? option.text : ''}
        getOptionSelected={(option, value) => option.value === value.value}
        onChange={(e, value) => {
          setValue(value)
          onChange(value)
        }}
        renderInput={(params) => (
          <TextField {...params}
            className='w-100'
            label={labelText}
            error={Boolean(error)}
            helperText={error}
            required={selectProps.required}
          />
        )}
        renderOption={(option, state) => {
          return <div className={option.marked ? 'bg-warning' : option.class} key={option.value} value={option.value}>{option.text}</div>
        }}
        filterOptions={createFilterOptions({
          stringify: (option) => convertHarfCharacter(option.text) + convertHarfCharacter(option.text, true) // 全角/半角に変換したものを両方検索対象として検索しやすくする
        })}
        disabled={selectProps.readonly}
      />
      <input ref={valueRef} type="text" name={selectProps.name} className="d-none" value={value ? value.value : -1} readOnly required={selectProps.required} />
    </>
      )
    : (
    <FormControl className='w-100' error={Boolean(error)} required={selectProps.required}>
      <InputLabel shrink>{labelText}</InputLabel>
      <Select
        inputRef={valueRef}
        id={selectProps.id}
        name={selectProps.name}
        defaultValue={selectProps.value}
        className={`w-100 ${selectProps.class}`}
        onChange={(e) => onChange(e.target)}
        disabled={selectProps.readonly}
        inputProps={{
          readOnly: selectProps.readonly
        }}
        displayEmpty>
        {options.map((option, i) => {
          return (
            <MenuItem key={option.value} value={option.value} className={option.class}>{option.text}</MenuItem>
          )
        })}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
      )

  )
}

MyReactSelect.propTypes = {
  labelText: PropTypes.string,
  selectProps: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.string,
  onChange: PropTypes.func,
  linkMode: PropTypes.bool,
  messagesOnSelected: PropTypes.arrayOf(PropTypes.array)
}

MyReactSelect.defaultProps = {
  error: '',
  onChange: () => {},
  linkMode: false,
  messagesOnSelected: []
}

const elem = $('.my-react-select')
elem.each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  const elLabel = qel.find('label')
  props.labelText = elLabel.length > 0 ? elLabel[0].innerText : ''
  const elSelect = qel.find('select')
  if (elSelect.length) {
    const qSelect = $(elSelect[0])
    props.selectProps = {}
    'id,name,class'.split(',').forEach((name) => {
      if (qSelect.attr(name)) {
        props.selectProps[name] = qSelect.attr(name)
      }
    })

    props.selectProps.readonly = qSelect.attr('readonly') && qSelect.attr('readonly').length > 0
    props.selectProps.required = qSelect.attr('required') && qSelect.attr('required').length > 0
    props.selectProps.useauto = qSelect.attr('useauto') && qSelect.attr('useauto').length > 0

    props.messagesOnSelected = []
    props.options = qSelect.find('option').map((i, el) => {
      const qOption = $(el)
      const obj = {
        value: qOption.prop('value'),
        text: qOption.text().trim(),
        class: qOption.attr('class')
      }
      if (qOption.prop('selected')) {
        props.selectProps.value = obj.value
      }
      if (qOption.data('messageOnSelected')) {
        props.messagesOnSelected.push([obj.value, qOption.data('messageOnSelected')])
      }
      return obj
    }).get()

    const elInvalidFeedback = qel.find('.invalid-feedback')
    props.error = elInvalidFeedback.length > 0 ? elInvalidFeedback[0].innerText : ''
  } else {
    console.error('my-react-selectクラスの子要素には必ずselect要素を配置してください。')
    return
  }
  ReactDOM.render(<MyReactSelect {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
